"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pageConfigApi = _interopRequireWildcard(require("@/api/productPageConfig.js"));
var _edit = _interopRequireDefault(require("./edit"));
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者,助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件,未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'ProductPageConfig',
  components: {
    editDialog: _edit.default
  },
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        productCode: '',
        pageName: '',
        status: null
      },
      editData: {}
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:product:page:config:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 列表查询
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      pageConfigApi.pageConfigListApi(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 分页切换
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    // 每页数量切换
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    },
    // 重置搜索
    resetForm: function resetForm() {
      this.tableFrom = {
        page: 1,
        limit: 20,
        productCode: '',
        pageName: '',
        status: null
      };
      this.getList(1);
    },
    // 新增
    onAdd: function onAdd() {
      this.editData = {};
      this.$refs.editDialog.dialogVisible = true;
    },
    // 编辑
    onEdit: function onEdit(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.$refs.editDialog.dialogVisible = true;
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this2 = this;
      this.$modalSure('确定删除该配置吗?此操作不可逆,请谨慎操作!').then(function () {
        pageConfigApi.pageConfigDeleteApi(id).then(function () {
          _this2.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this2.tableData.data.length, _this2.tableFrom);
          _this2.getList();
        });
      });
    },
    // 状态切换
    onChangeStatus: function onChangeStatus(row) {
      var _this3 = this;
      pageConfigApi.pageConfigUpdateStatusApi(row.id, row.status).then(function () {
        _this3.$message.success('状态更新成功');
        _this3.getList();
      });
    }
  }
};